<template>
    <div id="content_core_waybill">
        <QuickRelatedColumns
            v-if="current_core_waybill_need_related_columns.length &&
                settings.is_quick_corewaybill_related_columns_mode &&
                current_setting_group.is_scan_action"
            :is_inverted="is_inverted"
            >
        </QuickRelatedColumns>

        <div class="ui divider">
        </div>

        <h3 class="center aligned"
            style="margin: 0 auto; padding-bottom: 6px;"
            v-if="
                current_customer_operation.number ||
                settings.is_unpackage_mode ||
                settings.is_package_mode
            ">
            <span v-if="settings.is_package_mode">
                <!-- 包裝中 -->
                {{ $tc('ui.scanner.settings.is_package_mode.true', 3) }}
            </span>
            <span v-if="settings.is_unpackage_mode">
                <!-- 拆包中 -->
                {{ $tc('ui.scanner.settings.is_unpackage_mode.true', 3) }}
            </span>
            <span v-if="current_customer_operation.number">
                <span v-if="settings.is_package_mode || settings.is_unpackage_mode">
                    、
                </span>
                <!-- 已選擇訂單： -->
                {{ $t('ui.scanner.helps.selected_operation') }}：
                {{ current_customer_operation.number }}
                <span v-if="current_customer_operation.provider_note">
                    、{{ current_customer_operation.provider_note }}
                </span>
            </span>
        </h3>

        <div class="ui stackable centered grid">
            <div class="wide column">
                <!--
                    Author: @eziopu 2018-01-11
                    Note: 堆疊模式移除
                -->
                <!--
                    Author: @eziopu 2017-12-19
                    Note: 已選堆疊模式點選 若沒有core_waybills
                        按鈕要有提示 變換顏色,
                        一般單點模式卻不用,

                        CoreWaybillCard 不用額外抓貨況
                        SingleCoreWaybill 內部可以抓貨況

                        設定與操作差異過大 故分開使用
                -->
                <SingleCoreWaybill
                    :current_core_waybill="current_core_waybill"
                    :is_inverted="is_inverted"
                    :settings="settings"
                    :card_half_style="true"
                    :file_uploader="true"
                    :fetch_core_waybill_statuses="true"
                    :related_columns="current_scan_action_prototype.related_columns"
                    :current_scan_action_prototype="current_scan_action_prototype"
                    >
                </SingleCoreWaybill>

            </div>
        </div>

    </div>
</template>

<script>
import SingleCoreWaybill from './single.vue'
import QuickRelatedColumns from './quick_related_columns.vue'
import DistributedResponse from './distributed_response.vue'

export default {
    components: {
        SingleCoreWaybill,
        QuickRelatedColumns,
        DistributedResponse,
    },
    props: {
        core_waybill: Object,
        is_inverted: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            is_processing: true,
        }
    },
    mounted() {
        this.init()
    },
    watch: {
    },
    computed: {
        current_customer_operation() {
            return this.$store.state.customer.customer_operation || {}
        },
        current_store() {
            return this.$store.state[this.$store.state.current_scope].scanner_module
        },
        settings() {
            return this.current_store.settings
        },
        current_core_waybill: {
            cache: false,
            get() {
                return this.current_store.current_core_waybill
            }
        },
        core_waybills() {
            return this.current_store.core_waybills
        },
        current_scan_action_prototype() {
            return this.current_store.current_scan_action_prototype
        },
        current_setting_group() {
            return this.current_store.current_setting_group
        },
        current_core_waybill_need_related_columns() {
            return this.$store.getters['customer/scanner_module/current_core_waybill_need_related_columns']
        },
    },
    methods: {
        async init() {
            this.is_processing = true
            this.stack_error_number = []
            await new Promise(resolve => {
                this.is_processing = false
            })
        },
    },

}
</script>

<style lang="scss" scoped>
    .center.aligned {
        text-align: center;
    }
    .left.aligned {
        text-align: left;
    }
    .right.aligned {
        text-align: right;
    }
    #content_core_waybill {

    }
</style>
